import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { SupabaseService } from 'app/core/supabase';
import { Observable, catchError, from, switchMap, throwError } from 'rxjs';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    const supabase = inject(SupabaseService);

    // Get the session and add the access token to the request
    return from(supabase.session).pipe(
        switchMap((session) => {
            let newReq = req.clone();

            // If there's an active session, add the Authorization header
            if (session?.access_token) {
                newReq = req.clone({
                    headers: req.headers.set(
                        'Authorization',
                        'Bearer ' + session.access_token
                    ),
                });
            }

            // Response
            return next(newReq).pipe(
                catchError((error) => {
                    // Catch "401 Unauthorized" responses
                    if (
                        error instanceof HttpErrorResponse &&
                        error.status === 401
                    ) {
                        // Sign out
                        authService.signOut().subscribe(() => {
                            // Reload the app
                            location.reload();
                        });
                    }

                    return throwError(() => error);
                })
            );
        })
    );
};
